import React from 'react'
import s from '../seo/LayerCityIntroduction.less'
import useFirstAddressWithTownSeoPostcode from '../seo/useFirstAddressWithTownSeoPostcode'

const TrafficCityIntroduction = () => {
  const { town, postcode } = useFirstAddressWithTownSeoPostcode()

  return (
    <div className={s.root}>
      <h1 className={s.title}>
        Info trafic temps réel à {town}, {postcode}
      </h1>
      <p className={s.text}>
        Affichez sur la carte l'état du trafic en routier en direct pour la ville de {town} ({postcode}). Consultez
        l'état de la circulation en direct à {town} ({postcode}) : ralentissements, accidents, bouchons, travaux, voies
        fermées.
      </p>
    </div>
  )
}

export default TrafficCityIntroduction
